import type { IconsSet } from 'core/types';
import { DocumentType } from 'core/types/document';

const iconsCore: IconsSet = {
  [DocumentType.FOLDER]: 'fa-folder',
  [DocumentType.PLUGINS]: 'fa-plug',
  [DocumentType.PLUGINS_FOLDER]: 'fa-folder-o',
  [DocumentType.PLUGIN]: 'fa-file-code-o',
};

export { iconsCore };
